import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=24c868cf&scoped=true&"
import script from "./Department.vue?vue&type=script&lang=ts&"
export * from "./Department.vue?vue&type=script&lang=ts&"
import style0 from "./Department.vue?vue&type=style&index=0&id=24c868cf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c868cf",
  null
  
)

export default component.exports